(function (window, document) {
  'use strict';

  // One owner for event availability, submission, and the confirmed-signup marker.
  function initialize(root) {
    if (!root || root.dataset.ready === 'true') {
      return;
    }

    root.dataset.ready = 'true';

    var targetInput = root.dataset.targetDatetime;
    var target = new Date(targetInput).getTime();
    var daysNode = root.querySelector('[data-bd-webinar-days]');
    var hoursNode = root.querySelector('[data-bd-webinar-hours]');
    var minutesNode = root.querySelector('[data-bd-webinar-minutes]');
    var secondsNode = root.querySelector('[data-bd-webinar-seconds]');

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }

    function tick() {
      updateAvailability();
      var diff = target - Date.now();

      if (isNaN(target) || diff <= 0) {
        daysNode.textContent = '00';
        hoursNode.textContent = '00';
        minutesNode.textContent = '00';
        secondsNode.textContent = '00';
        return;
      }

      var dayMs = 86400000;
      var hourMs = 3600000;
      var minuteMs = 60000;
      var days = Math.floor(diff / dayMs);
      diff -= days * dayMs;
      var hours = Math.floor(diff / hourMs);
      diff -= hours * hourMs;
      var minutes = Math.floor(diff / minuteMs);
      diff -= minutes * minuteMs;
      var seconds = Math.floor(diff / 1000);

      daysNode.textContent = pad(days);
      hoursNode.textContent = pad(hours);
      minutesNode.textContent = pad(minutes);
      secondsNode.textContent = pad(seconds);
    }

    var form = root.querySelector('form.optin');
    var closedNode = root.querySelector('[data-bd-webinar-closed]');
    var countdownNode = root.querySelector('[data-bd-webinar-countdown]');
    var state = 'idle';
    var nameInput = root.querySelector('input[name="name"]');
    var emailInput = root.querySelector('input[name="email"]');
    var phoneInput = root.querySelector('input[name="phone"]');

    /**
     * Attribution, best effort. Every URL parameter present on the page plus
     * the referrer, so the server-side note records where a registration came
     * from. Never throws, never blocks the signup.
     */
    function collectSource() {
      var out = {};
      try {
        var seen = 0;
        new URLSearchParams(window.location.search).forEach(function (value, key) {
          if (seen < 12) {
            out[String(key).slice(0, 40)] = String(value).slice(0, 200);
            seen += 1;
          }
        });
        if (document.referrer) out.referrer = document.referrer.slice(0, 200);
      } catch (error) {
        /* attribution is a nice-to-have; a signup never fails for it */
      }
      return out;
    }
    var submitButton = root.querySelector('.submit');
    var statusNode = root.querySelector('[data-bd-webinar-status]');
    var submitLabel = submitButton ? submitButton.innerHTML : '';
    var registrationMarkerKey = 'bd:masterclass-registration:v1';
    var requestId;
    var requestFingerprint;

    function updateAvailability() {
      var closed = !Number.isFinite(target) || Date.now() >= target;
      if (state === 'submitting' || state === 'confirmed') return;
      state = closed ? 'closed' : 'idle';
      form.hidden = closed;
      closedNode.hidden = !closed;
      countdownNode.hidden = closed;
      submitButton.disabled = closed;
    }

    function setSubmitting(isSubmitting) {
      state = isSubmitting ? 'submitting' : 'idle';
      if (!submitButton) {
        return;
      }

      submitButton.disabled = isSubmitting;
      submitButton.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      submitButton.style.opacity = isSubmitting ? '.72' : '';
      submitButton.style.cursor = isSubmitting ? 'wait' : '';
      submitButton.innerHTML = isSubmitting
        ? '<span class="submit__chev">&raquo;</span>Saving your seat...'
        : submitLabel;
    }

    function showSignupError(message) {
      if (!statusNode) {
        return;
      }

      statusNode.textContent = message;
      statusNode.hidden = false;
    }

    function createRegistrationEventId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }

      return 'bd-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }

    function recordRegistrationSuccess() {
      try {
        window.sessionStorage.setItem(registrationMarkerKey, JSON.stringify({
          eventId: createRegistrationEventId(),
          createdAt: Date.now()
        }));
      } catch (error) {
        // Signup must still complete when session storage is unavailable.
      }
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      updateAvailability();
      if (state !== 'idle') return;

      var endpoint = form.action;
      var successPath = form.dataset.successPath;
      if (statusNode) {
        statusNode.hidden = true;
      }
      setSubmitting(true);
      var failureMessage = 'We could not save your seat just now. Please try again.';

      var registration = {
        name: nameInput ? nameInput.value : '',
        email: emailInput ? emailInput.value : '',
        phone: phoneInput ? phoneInput.value : '',
        cohort: form.dataset.cohort,
        source: collectSource()
      };
      if (phoneInput && registration.phone.trim()) {
        registration.whatsAppConsent = {
          granted: true,
          disclosureVersion: 'masterclass-whatsapp-reminders-v1'
        };
      }
      var fingerprint = JSON.stringify(registration);
      if (requestFingerprint !== fingerprint) {
        requestFingerprint = fingerprint;
        requestId = createRegistrationEventId();
      }
      registration.requestId = requestId;

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'accept': 'application/json'
          },
          body: JSON.stringify(registration)
        });
        var payload = await response.json();

        if (!response.ok || !payload || !payload.ok) {
          failureMessage = payload && payload.message
            ? payload.message
            : failureMessage;
          throw new Error('Signup request failed');
        }

        state = 'confirmed';
        recordRegistrationSuccess();
        if (!successPath) throw new Error('Signup redirect is not configured');
        successPath = window.BDMasterclassHandoff
          ? window.BDMasterclassHandoff.captureRegistration(payload, registration, successPath)
          : successPath.split('#')[0] + '#mc_registered=1';

        window.location.replace(successPath);
      } catch {
        if (state === 'confirmed') {
          showSignupError('Your masterclass seat is saved. We could not open the welcome page. Please keep your confirmation email for the event details.');
          submitButton.innerHTML = 'Your seat is saved';
          submitButton.setAttribute('aria-busy', 'false');
          return;
        }
        showSignupError(failureMessage);
        setSubmitting(false);
        updateAvailability();
      }
    });

    tick();
    window.setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-bd-masterclass]').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bd-masterclass]').forEach(initialize);
  });
})(window, document);
